<route>{ "meta": { "moduleCode": "VEHICLE_WORK_ORDER" } }</route>
<template>
    <PageHeader :title="$t('pages.module.VEHICLE_WORK_ORDER.type.title')" back-to="/module/vehicle-work-order"/>

    <custom-table
        :title="$t('pages.module.VEHICLE_WORK_ORDER.type.title')"
        :subTitle="$t('pages.module.VEHICLE_WORK_ORDER.type.subTitle')"
        rowKey="id"
        :items="table.data"
        :loading="table.loading"
        selectableRows
        :columns="fields"
        :actions="actions"
        :pagination="table.pagination"
        changeUrlPage
        @action="handleClickAction"
        @selectableRows="handleSelectedRow"
        @changeTable="handleTableChange"
    >
        <template v-slot:name="{ row: record }">
            {{ record.name }}
        </template>
        <template v-slot:description="{ row: record }">
            {{ record.description }}
        </template>
        <template v-slot:actions="{ row: record }">
            <div class="d-flex justify-content-end">
                <el-tooltip :content="$t('common.edit')" placement="top">
                    <button @click="newVehicleWorkOrderType(record)" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1">
                     <span class="svg-icon svg-icon-3">
                         <inline-svg src="/media/icons/duotune/art/art005.svg"/>
                     </span>
                    </button>
                </el-tooltip>
                <el-popconfirm :title="$t('messages.sureDelete')" :confirm-button-text="$t('btn.yes')" :cancel-button-text="$t('btn.no')" @confirm="deleteRecord([record.id])">
                    <template #reference>
                        <a class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm">
                            <span class="svg-icon svg-icon-3">
                                <inline-svg src="/media/icons/duotune/general/gen027.svg"/>
                            </span>
                        </a>
                    </template>
                </el-popconfirm>
            </div>
        </template>
    </custom-table>

    <div class="modal fade" id="kt_modal_vehicle_work_order_type" ref="vehicleWorkOrderTypeModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered mw-650px">
            <div class="modal-content">
                <div class="modal-header">
                    <h2 class="fw-bolder">{{ form.title }}</h2>
                    <div id="kt_modal_add_customer_close" data-bs-dismiss="modal" class="btn btn-icon btn-sm btn-active-icon-primary">
                        <span class="svg-icon svg-icon-1">
                            <inline-svg src="/media/icons/duotune/arrows/arr061.svg"/>
                        </span>
                    </div>
                </div>
                <el-form @submit.prevent="onSubmit()" :model="form.data" ref="vehicleWorkOrderTypeForm">
                    <div class="modal-body py-10 px-lg-17">
                        <div class="scroll-y me-n7 pe-7" id="kt_modal_add_customer_scroll" data-kt-scroll="true" data-kt-scroll-activate="{default: false, lg: true}" data-kt-scroll-max-height="auto" data-kt-scroll-dependencies="#kt_modal_add_customer_header" data-kt-scroll-wrappers="#kt_modal_add_customer_scroll" data-kt-scroll-offset="300px">
                            <div class="fv-row mb-7">
                                <label class="required fs-6 fw-bold mb-2">{{ $t('pages.module.VEHICLE_WORK_ORDER.type.cols.name') }}</label>
                                <el-form-item prop="name" :rules="$validation.getMessage(['required'])">
                                    <el-input v-model="form.data.name" type="text"/>
                                </el-form-item>
                            </div>
                            <div class="fv-row mb-7">
                                <label class="fs-6 fw-bold mb-2">{{ $t('pages.module.VEHICLE_WORK_ORDER.type.cols.description') }}</label>
                                <el-form-item prop="description">
                                    <el-input v-model="form.data.description" type="text"/>
                                </el-form-item>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer flex-center">
                        <button :data-kt-indicator="form.loading ? 'on' : null" class="btn btn-lg btn-primary" type="submit" :disabled="form.loading">
                            <span v-if="!form.loading" class="indicator-label">{{ $t("btn.save") }}</span>
                            <span v-if="form.loading" class="indicator-progress">
                                {{ $t("messages.wait") }}
                                <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span>
                        </button>
                    </div>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import CustomTable from "@/components/custom-table";
import PageHeader from "@/components/page-header/PageHeader.vue";

export default {
    name: "vehicle-work-order-type",
    components: {
        PageHeader,
        CustomTable
    },
    data() {
        return {
            fields: [
                {
                    name: this.$t("pages.module.VEHICLE_WORK_ORDER.type.cols.id"),
                    key: "id",
                    class: ""
                },
                {
                    name: this.$t("pages.module.VEHICLE_WORK_ORDER.type.cols.name"),
                    scopedSlots: {customRender: "name"}
                },
                {
                    name: this.$t("pages.module.VEHICLE_WORK_ORDER.type.cols.description"),
                    scopedSlots: {customRender: "description"}
                },
                {
                    name: this.$t("common.action"),
                    key: "action",
                    scopedSlots: {customRender: "actions"}
                }
            ],
            actions: [
                {
                    name: "new",
                    icon: "bi-plus-lg",
                    label: "btn.add"
                },
                {
                    name: "refresh",
                    icon: "bi-arrow-repeat",
                    label: "btn.refresh"
                },
                {
                    name: "delete",
                    icon: "bi-trash",
                    label: "btn.delete"
                }
            ],
            rules: {},
            selectedRowKeys: [],
            filterParameters: {},
            exportLoading: false,
            form: {
                title: '',
                loading: false,
                updateStatus: false,
                data: {}
            },
        }
    },
    created() {
    },
    computed: {
        table() {
            return this.$store.state.module.vehicle_work_order.type.table;
        },
        selectedCompany() {
            return this.$store.state.company.authorized.selectCompany
        }
    },
    mounted() {
        this.setCurrentPageBreadcrumbs(this.$t('pages.module.VEHICLE_WORK_ORDER.type.title'), [this.$t('pages.module.VEHICLE_WORK_ORDER.title')]);

        this.filterParameters = {
            sort: 'created_at:desc'
        };
        this.refreshTable()
    },
    methods: {
        handleClickAction(name) {
            switch (name) {
                case "refresh":
                    this.refreshTable();
                    break;

                case "new":
                    this.newVehicleWorkOrderType();
                    break;

                case "delete":
                    this.deleteRecord(this.selectedRowKeys.flat());
                    break;

                default:
                    break;
            }
        },
        refreshTable() {
            this.$store.dispatch('module/vehicle_work_order/type/get', {
                page: {
                    current: this.$route.query.page
                },
                filterData: Object.assign(this.filterParameters, this.$root.getFilterWithUrl({}))
            });
        },
        handleTableChange(pagination, filterData) {
            this.filterParameters = Object.assign({
                sort: 'created_at:desc',
            }, filterData);

            this.$store.dispatch("customer/get", {
                page: pagination,
                filterData: this.filterParameters
            });
        },
        handleSelectedRow(record) {
            this.selectedRowKeys = record;
        },
        newVehicleWorkOrderType(record = null) {
            this.form.updateStatus = false;
            this.form.data = {
                sort: 1,
                parent_id: null,
                active: true
            };
            this.form.title = this.$t("pages.module.VEHICLE_WORK_ORDER.type.newItem");

            if (record) {
                this.form.title = this.sprintf(this.$t("pages.module.VEHICLE_WORK_ORDER.type.editItemPattern"), [record.name]);
                this.form.updateStatus = true;
                this.form.data.id = record.id;
                this.form.data.name = record.name;
                this.form.data.description = record.description;
            }

            this.showModal(this.$refs.vehicleWorkOrderTypeModal);
        },
        onSubmit() {
            this.$refs.vehicleWorkOrderTypeForm.validate((valid) => {
                if (valid) {
                    this.form.data.company_id = this.selectedCompany;
                    let formData = this.form.data;
                    this.form.loading = true;

                    if (this.form.updateStatus) {
                        this.axios.put(this.endpoints['module_vehicle_work_order_type'] + '/' + this.form.data.id, formData).then(response => {
                            this.onResponse(response.data, () => {
                                this.refreshTable();
                                this.hideModal(this.$refs.vehicleWorkOrderTypeModal);
                            }, () => {
                                this.form.loading = false;
                            });
                        }).catch(error => {
                            this.onResponseFailure(error.response.data, () => {
                                this.form.loading = false;
                            });
                        });
                    } else {
                        this.axios.post(this.endpoints['module_vehicle_work_order_type'], formData).then(response => {
                            this.onResponse(response.data, () => {
                                this.refreshTable();
                                this.hideModal(this.$refs.vehicleWorkOrderTypeModal);
                            }, () => {
                                this.form.loading = false;
                            });
                        }).catch(error => {
                            this.onResponseFailure(error.response.data, () => {
                                this.form.loading = false;
                            });
                        });
                    }
                } else {
                    return false;
                }
            });
        },
        deleteRecord(id) {
            this.$store.dispatch("module/vehicle_work_order/type/delete", {
                id: id
            }).then((successDeleted) => {
                this.selectedRowKeys = this.selectedRowKeys.filter(x => !successDeleted.includes(x));
            });
        },
    }
}
</script>

<style scoped>

</style>